/** * Created by lobin on 2019/3/2. */
<template>
  <div class="wechat-auth"></div>
</template>

<script type="text/babel">
import { mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  async created() {
    const code = this.$route.query.code;
    if (!code) {
      this.$message.error("code不存在，请重试");
      return this.$router.go(-1);
    }
    const data = await this.wechatBond(code);
    if (data.code === 200) {
      this.$message.success("绑定成功");
      return this.$router.replace({ name: "bingingAccount" });
    } else {
      this.$message.error(data.message);
      return this.$router.go(-1);
    }
  },
  methods: {
    ...mapActions(["wechatBond"])
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.wechat-auth {
}
</style>
